export const LABEL_TASTING_FEATURE = "special marking";
